import classNames from 'classnames'

export const ButtonsLayout = ({ className, children }: { className?: string; children: React.ReactNode }) => {
    return <div className={classNames('flex mx-auto', className)}>{children}</div>
}

export const ButtonWrapper = ({ className, children }: { className?: string; children: React.ReactNode }) => {
    return <div className={classNames('w-16 px-2 flex flex-col items-center', className)}>{children}</div>
}

export const ButtonLabel = ({ className, children }: { className?: string; children: React.ReactNode }) => {
    return <div className={classNames('text-gray-500 mt-1', className)}>{children}</div>
}
